export function encode(component) {
  return component.replace(/[\/\.\$\[\]#!]/g, function (match) {
    return "!" + match.charCodeAt(0).toString(16).toUpperCase();
  });
}